module.exports = __webpack_public_path__ + "ClientApp/images/content/mary-sam-and-duncan-small.jpg";